/**
 * Web-only override for the old bsky DM chat-request inbox route.
 *
 * Expo/Metro platform resolution picks this `.web.tsx` file INSTEAD of the
 * suffix-less `Inbox.tsx` on web builds, so `Navigation.tsx`'s
 * `import {MessagesInboxScreen} from '#/screens/Messages/Inbox'` resolves here
 * on web. The native inbox is untouched and still serves native builds.
 *
 * The native screen calls `useMessagesEventBus()`, which requires the bsky DM
 * provider stack (`MessagesEventBusProvider`) that web no longer mounts (see
 * `src/state/messages/index.web.tsx` — DME is the sole chat system on web), so
 * it would crash if rendered here. Old deep links redirect to `/messages`,
 * where the keep-mounted DME iframe lives.
 *
 * Rollback: delete this file to restore the old web chat-request inbox.
 */

import {useEffect} from 'react'
import {useNavigation} from '@react-navigation/native'
import type React from 'react'

import {type NavigationProp} from '#/lib/routes/types'

export function MessagesInboxScreen(): React.JSX.Element {
  const navigation = useNavigation<NavigationProp>()

  useEffect(() => {
    navigation.navigate('Messages')
  }, [navigation])

  return null
}
